export default __webpack_public_path__ + "static/media/safe.817e01b8.svg";